import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import SydButton from '../../../../../../../commonDesign/Button'
import SydSelect from '../../../../../../../commonDesign/SydSelect'

function FooterMappingEditor ({
  localConfig,
  getFooterColumnForMain,
  onFooterMappingChange,
  footerColumnSelectOptions,
  mappedColumnCount,
  onAutoConfigure,
  onClear
}) {
  const columns = localConfig.columns || []

  return (
    <Grid item xs={12}>
      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <h4 style={{ margin: 0 }}>Footer Column Mapping</h4>
        <span style={{ fontSize: '0.875rem', color: 'var(--text-color-subtle)' }}>
          ({mappedColumnCount} of {columns.length} mapped)
        </span>
        <SydButton
          size='sm'
          icon='sync'
          onClick={onAutoConfigure}
          disabled={columns.length === 0}
        >
          Auto-Configure
        </SydButton>
        {mappedColumnCount > 0
          ? (
            <SydButton
              size='sm'
              variant='ghost'
              onClick={onClear}
            >
              Clear All
            </SydButton>
          )
          : null}
      </div>
      <p style={{ fontSize: '0.875rem', color: 'var(--text-color-subtle)', marginTop: 0, marginBottom: '12px' }}>
        Map main columns to footer columns for alignment. Auto-Configure matches columns with the same name.
      </p>

      {columns.length > 0 ? (
        <Table className='opal-presentation-table zebra-rows' size='small'>
          <TableHead className='opt-thead'>
            <TableRow className='opt-tr'>
              <TableCell className='opt-th' style={{ width: '50%' }}>Main Column</TableCell>
              <TableCell className='opt-th' style={{ width: '50%' }}>Footer Column</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='opt-tbody'>
            {columns.map((col) => (
              <TableRow className='opt-tr' key={col.name}>
                <TableCell className='opt-td' style={{ fontWeight: 500 }}>
                  {col.displayName || col.name}
                  {col.displayName && col.displayName !== col.name
                    ? (
                      <span style={{ color: 'var(--text-color-subtle)', marginLeft: '8px', fontSize: '0.75rem' }}>
                        ({col.name})
                      </span>
                    )
                    : null}
                </TableCell>
                <TableCell className='opt-td'>
                  <SydSelect
                    options={footerColumnSelectOptions}
                    value={getFooterColumnForMain(col.name)}
                    onChange={(e) => onFooterMappingChange(col.name, e.target.value === '__none__' ? null : e.target.value)}
                    size='sm'
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <p style={{ color: 'var(--text-color-subtle)', fontSize: '0.875rem', margin: 0 }}>
          No columns configured. Select a data purpose first.
        </p>
      )}
    </Grid>
  )
}

FooterMappingEditor.propTypes = {
  localConfig: PropTypes.object.isRequired,
  getFooterColumnForMain: PropTypes.func.isRequired,
  onFooterMappingChange: PropTypes.func.isRequired,
  footerColumnSelectOptions: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })).isRequired,
  mappedColumnCount: PropTypes.number.isRequired,
  onAutoConfigure: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
}

export default FooterMappingEditor
